<div
  class="absolute top-0 z-50 flex h-full w-full flex-col justify-center bg-bo-black/60 backdrop-blur-sm"
>
  <div>
    <div
      class="bo-subheader mb-3 flex animate-pulsation justify-center !text-bo-white"
    >
      Uploading data
    </div>
    <div class="flex h-8 w-full bg-bo-white">
      <div class="flex h-full w-full bg-bo-primary/20">
        <div
          class="text-bo-title flex items-center justify-center bg-bo-primary !text-bo-white"
          [style.width.%]="progress()"
        ></div>
        <div class="flex-1"></div>
      </div>
    </div>
    @if (environment.sandbox) {
      <div class="mt-4 flex justify-center">
        <button class="bo-button" (click)="loggingService.saveLogToFile()">
          Save Logfile
        </button>
      </div>
    }
  </div>
</div>
